import { AlertTriangle, UserRound, Wallet } from 'lucide-react';
import { WORKLIST_SORT_LABELS, type WorklistSort, toOptions } from '#shared/types';
import { DensityControl } from '#client/components/ui/DensityControl';
import { SearchFilter } from '#client/components/ui/SearchFilter';
import { Select } from '#client/components/ui/Select';
import { FilterChip } from '#client/components/ui/Tabs';
import type { WorklistFilters, WorklistFlag } from './useWorklist';

const SORT_OPTIONS = toOptions(WORKLIST_SORT_LABELS);

/** Search, the three filter chips, the sort and the row density. */
export function WorklistFilterBar({
  filters,
  onSearchChange,
  onToggle,
  onSortChange,
}: {
  filters: WorklistFilters;
  onSearchChange: (value: string) => void;
  onToggle: (flag: WorklistFlag) => void;
  onSortChange: (sort: WorklistSort) => void;
}) {
  return (
    <div className="c-worklist-filters">
      <div className="c-worklist-filters__search">
        <SearchFilter
          value={filters.search}
          onChange={onSearchChange}
          placeholder="Search by patient, PIN, MR number, phone or test"
        />
      </div>

      <FilterChip active={filters.overdue} onClick={() => onToggle('overdue')}>
        <AlertTriangle aria-hidden="true" />
        Overdue
      </FilterChip>
      <FilterChip active={filters.unpaid} onClick={() => onToggle('unpaid')}>
        <Wallet aria-hidden="true" />
        Unpaid
      </FilterChip>
      <FilterChip active={filters.mine} onClick={() => onToggle('mine')}>
        <UserRound aria-hidden="true" />
        Mine
      </FilterChip>

      <Select
        label="Sort"
        hideLabel
        options={SORT_OPTIONS}
        value={filters.sort}
        onChange={(choice) => onSortChange(choice)}
      />

      <DensityControl />
    </div>
  );
}
